// export const openPicker = async data => {
//   const pickerController = document.querySelector('ion-picker-controller')
//   await pickerController.componentOnReady()

//   const picker = await pickerController.create({
//     columns: getColumns(1, data),
//     buttons: [
//       { text: 'Cancel', role: 'cancel' },
//       {
//         text: 'OK',
//         // handler: v => {
//         //   value = v
//         // }
//       }
//     ]
//   })
//   return picker.present()
// }

export const getColumns = (numColumns, columnOptions) => {
  let columns = [];
  for (let i = 0; i < numColumns; i++) {
    let len = columnOptions[i].data.length;
    // if a na,e is provided then set the object to the
    // the name provided
    let colName = columnOptions[i].name || `col-${i}`;
    let col = {
      name: colName,
      options: getColumnOptions(i, len, columnOptions)
    };
    columns.push(col);
  }
  return columns;
}

export const getColumnOptions = (columnIndex, numOptions, columnOptions) => {
  let options = [];
  for (let i = 0; i < numOptions; i++) {
    // if there is no value property provided in the column data
    // then set value to the row index
    if (typeof columnOptions[columnIndex].data[i] == "object") {
      options.push({
        text: columnOptions[columnIndex].data[i % numOptions][0],
        value: columnOptions[columnIndex].data[i % numOptions][1]
      });
    }
    else {
      options.push({
        text: columnOptions[columnIndex].data[i % numOptions],
        value: i
      });
    }
  }
  return options;
}
